import { render } from "./KpiChat.vue?vue&type=template&id=53c42a91&scoped=true"
import script from "./KpiChat.vue?vue&type=script&lang=js"
export * from "./KpiChat.vue?vue&type=script&lang=js"

import "./KpiChat.vue?vue&type=style&index=0&id=53c42a91&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c42a91"]])

export default __exports__